import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Select from '../../ui/Select/Select'
import { Checkbox } from '../../ui'

const CHECKBOX_LABEL_CLASS = 'tw:flex! tw:items-center tw:gap-2 tw:cursor-pointer tw:m-0!'
const CHECKBOX_TEXT_CLASS = 'tw:text-sm tw:text-gray-900'

const ExternalEmailsField = ({
  useExternalEmails, variableId, variableOptions, variableError, onFieldChange
}) => {
  const handleCheckboxChange = useCallback(event => {
    onFieldChange('useExternalEmails', event.target.checked)
  }, [onFieldChange])

  const handleVariableChange = useCallback(option => {
    onFieldChange('variableId', option?.value)
  }, [onFieldChange])

  const selectedVariable = variableOptions.find(
    option => option.value === variableId
  ) || null

  return (
    <div className="form-group">
      <label className={CHECKBOX_LABEL_CLASS}>
        <Checkbox checked={useExternalEmails} onChange={handleCheckboxChange} />
        <span className={CHECKBOX_TEXT_CLASS}>
          Ajouter des destinataires en utilisant une variable
        </span>
      </label>
      {useExternalEmails ? (
        <>
          <Select
            className="mt-2"
            options={variableOptions}
            value={selectedVariable}
            placeholder="Variable de contact"
            error={Boolean(variableError)}
            onChange={handleVariableChange}
          />
          {variableError ? <small className="text-danger">{variableError[0]}</small> : null}
        </>
      ) : null}
    </div>
  )
}

ExternalEmailsField.propTypes = {
  onFieldChange: PropTypes.func.isRequired,
  useExternalEmails: PropTypes.bool.isRequired,
  variableError: PropTypes.arrayOf(PropTypes.string),
  variableId: PropTypes.number,
  variableOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })).isRequired
}

ExternalEmailsField.defaultProps = { variableError: null, variableId: null }

export default ExternalEmailsField
